import { mergeExtendedSourceNetworks } from "../lib/extendedRoutes/registry";
export class LayerSwapAppSettings {
    constructor(settings) {
        const flags = settings.featureFlags;
        this.networks = mergeExtendedSourceNetworks(settings.networks, flags);
        this.sourceExchanges = settings.sourceExchanges || [];
        this.sourceRoutes = settings.sourceRoutes || [];
        this.destinationRoutes = settings.destinationRoutes || [];
        this.extendedRouteFlags = flags;
    }
}
